import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CatalogueHighlightFilter" })
export default class CatalogueHighlightFilter extends Vue {
    public localizer: any = Localizer;
    public isAreaListVisible: boolean = true;
    public isCategoryListVisible: boolean = true;
    public filterData: any = { areas: [], categories: [] };
    public areaIndex: number = 5;
    public categoryIndex: number = 5;
    public isShow: boolean = false;
    public areaName: string = null;
    public categoryName: string = null;
    public selectedArea: any = null;
    public selectedCategory: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const urlParams = new URLSearchParams(window.location.search);

        this.areaName = urlParams.get("area");
        this.categoryName = urlParams.get("category");

        const response = (await Axios.post(this.routes.CatalogueHighlight_GetCatalogueHighlightFilters)).data;

        this.filterData.areas = response.areas;
        this.filterData.categories = response.categories;

        if (this.areaName) {
            this.selectedArea = this.areaName ? this.filterData.areas.find(x => x.value === this.areaName) : null;

            if (this.selectedArea) {
                this.categoryName = null;
            }
        } else if (this.categoryName) {
            this.selectedCategory = this.categoryName ? this.filterData.categories.find(x => x.value === this.categoryName) : null;
        }

        if (this.areaName || this.categoryName || this.$route.query.hasOwnProperty("anchor")) {
            document.getElementById('Promotions').scrollIntoView();
        }
    }

    public updateUrl(detailUrl: string) {
        window.location.href = detailUrl;
    }

    public resetFilter() {
        window.location.href = window.location.pathname + "?anchor";
    }

    public setIsAreaListVisible() {
        this.isAreaListVisible = !this.isAreaListVisible;
    }

    public setIsCategoryListVisible() {
        this.isCategoryListVisible = !this.isCategoryListVisible;
    }

    public plus(section: string) {
        switch (section) {
            case "area":
                this.areaIndex = 999;
                break;
            case "category":
                this.categoryIndex = 999;
                break;
        }
    }

    public less(section: string) {
        switch (section) {
            case "area":
                this.areaIndex = 5;
                break;
            case "category":
                this.categoryIndex = 5;
                break;
        }
    }

    public setShow() {
        this.isShow = !this.isShow;
    }
};